import { SafeParseError, SafeParseSuccess, ZodIssue } from 'zod';

import { OptionItemObject } from '../../../shared_models/interfaces';
import { ValidationResult } from '../model';

export type VResult = {
    id?: string;
    invalidValue?: string;
    path?: (string | number)[];
};

export interface Validator<T,I,Z> {
    getStatistics(json: T): { toAdd: number; toUpdate: number; };
    isSuccess(validationResult:
        | SafeParseError<Z>
        | SafeParseSuccess<Z>): boolean;
    validate(data: I, treeData: OptionItemObject[]): ValidationResult;
}

const findInvalidValueInParams = (params: { invalidValue: string }[] = []): string | undefined => {
    return params.find(item => item.invalidValue !== undefined)?.invalidValue;
};

export const DUPLICATE_OPTION_NAME_ERROR = 'Duplicated option name';
export const INVALID_OPTION_ID_ERROR= 'Invalid option id';
export const INVALID_OPTION_NAME_ERROR= 'Invalid option name';
export const getInvalidValue = (item: ZodIssue): string => {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const customParamsInvalidValue = findInvalidValueInParams(item.params);
    // @ts-ignore
    const unionsInvalidValues = item.unionErrors?.length ? item.unionErrors[0]?.issues[0]?.received : undefined;
    return customParamsInvalidValue !== undefined ? customParamsInvalidValue : unionsInvalidValues;
};
